import { render, staticRenderFns } from "./HeaderDispatcher.vue?vue&type=template&id=d0d300a6&"
import script from "./HeaderDispatcher.vue?vue&type=script&lang=js&"
export * from "./HeaderDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports